import { FC } from 'react';
import ServicesInfoItem from './ServicesInfoItem';
import { ServicesInfoType } from '@/types';

interface IServicesInfoProps {
  servicesInfo: ServicesInfoType[];
}

const ServicesInfo: FC<IServicesInfoProps> = ({ servicesInfo }) => {
  return (
    <>
      <div className={'card-set [--card-gap:10px]'}>
        {servicesInfo.map(({ id, text, textSubMenu }: ServicesInfoType) => (
          <ServicesInfoItem
            key={id}
            className={'card-set-item'}
            text={text}
            textSubMenu={textSubMenu}
          />
        ))}
      </div>
    </>
  );
};

export default ServicesInfo;
